var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", "justify-end": "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs2: "",
                                sm2: "",
                                md2: "",
                                "align-end": ""
                              }
                            },
                            [_c("p", [_vm._v("Total Neto")])]
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", sm2: "", md2: "" } },
                            [
                              _c("p", [
                                _vm._v(
                                  "$ " +
                                    _vm._s(
                                      _vm.facturaSeleccionada.totalNeto.toLocaleString()
                                    )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { row: "", "justify-end": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", sm2: "", md2: "" } },
                            [_c("p", [_vm._v("IVA 19%")])]
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", sm2: "", md2: "" } },
                            [
                              _c("p", [
                                _vm._v(
                                  "$ " +
                                    _vm._s(
                                      _vm.facturaSeleccionada.totalIva.toLocaleString()
                                    )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { row: "", "justify-end": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", sm2: "", md2: "" } },
                            [_c("p", [_vm._v("Total")])]
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", sm2: "", md2: "" } },
                            [
                              _c("p", [
                                _vm._v(
                                  "$ " +
                                    _vm._s(
                                      _vm.facturaSeleccionada.total.toLocaleString()
                                    )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }